module.exports = __webpack_public_path__ + "img/apetrus.9ba5e924.png";